'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Joi = require('joi');
var pageDataschema_model = require('../EventRegistry/eventSchemas/utils/pageDataschema.model.js');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var Joi__default = /*#__PURE__*/_interopDefault(Joi);

var StandardPayloadFields = Object.assign({
  user_id: Joi__default["default"].string().guid({
    version: ['uuidv4']
  }).allow(null).required().description('Anonymous Id for guests, Hype User id when authenticated'),
  publisher_id: Joi__default["default"].string().guid({
    version: ['uuidv4']
  }).allow(null).optional().description('Publisher user logged into their account from'),
  session_id: Joi__default["default"].string().guid({
    version: ['uuidv4']
  }).required().description('Id of current session'),
  referrer: Joi__default["default"].string().uri({
    allowRelative: false
  }).allow(null, '').description('Origin of traffic'),
  locale: Joi__default["default"].string().allow(null).description('Locale of user browser'),
  campaign: Joi__default["default"].object().keys({
    content: Joi__default["default"].string().default(null).description('Ad Campaign content'),
    medium: Joi__default["default"].string().default(null).description('Ad Campaign medium'),
    name: Joi__default["default"].string().default(null).description('Ad Campaign name'),
    source: Joi__default["default"].string().default(null).description('Ad Campaign source'),
    term: Joi__default["default"].string().default(null).description('Ad Campaign term')
  }).required().description('UTM Info for active Ad Campaigns'),
  context: Joi__default["default"].string().valid('signup', 'dashboard', 'landing_page', 'gadget').required().description('App event call originated from')
}, pageDataschema_model, {
  form_id: Joi__default["default"].string().guid({
    version: ['uuidv4']
  }).allow(null).optional().description('Id associated to the form (Offer) the user is on.')
});
Joi__default["default"].object().keys(StandardPayloadFields).description("Standard Attributes are data that we pass and collect from storage\n        that we aggregate and pass with every event call, regardless of the type or purpose.").meta({
  name: 'StandardPayload',
  filename: 'standardPayload'
});

exports.StandardPayloadFields = StandardPayloadFields;
//# sourceMappingURL=standardPayload.model.js.map
